import { render, staticRenderFns } from "./RoundedGroup.vue?vue&type=template&id=8a608526"
import script from "./RoundedGroup.vue?vue&type=script&lang=js"
export * from "./RoundedGroup.vue?vue&type=script&lang=js"
import style0 from "./RoundedGroup.vue?vue&type=style&index=0&id=8a608526&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports